import Vue from 'vue';
import {MutationTree} from "vuex";
import { ProductAdminzoneState } from "@/types/store/adminzone/products";
import { ProductData } from "@/types/product";

export const mutations: MutationTree<ProductAdminzoneState> = {
  SET_PRODUCTS: (state, payload: Array<ProductData>): Array<ProductData> => Vue.set(state, 'products', payload)
}
